import React from "react"
import App from "../App"
import "sanitize.css"
import "./index.scss"

export default () => <App />
